export default {
    list: 'Documents',
    grid: {
		gridId:'dropZoneGrid',
		checkbox: true,
		delete: false,
		edit:false,
		editable:true
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable:false,
			readOnly:true
		},
		File: {
			class: 'value',
			dataName: 'File',
			type: 'string',
			title: 'File Name',
			width: 150,
			hidden: false,
			readOnly:true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'Program/Id',
			type: 'number',
			title: 'ProgramId',
			width: 100,
			hidden: true,
			readOnly:false,
			editable:false
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			//dropdown: true,
			//source:'ProgramTypeOptions',
			title: 'Program',
			width: 150,
			hidden: true,
			editable:false,
			readOnly:true
		},
		PartnerId: {
			class: 'lookup',
			dataName: 'Partner/Id',
			type: 'number',
			title: 'PartnerId',
			width: 100,
			hidden: true,
			readOnly:false,
			editable:false
		},
		PartnerTitle: {
			class: 'lookup',
			dataName: 'Partner/FullName',
			type: 'string',
			//dropdown: true,
			//source:'PartnerTypeOptions',
			title: 'Partner',
			width: 150,
			hidden: true,
			editable:false,
			readOnly:true
		},
		DocumentType: {
			class: 'choice',
			dataName: 'DocumentType',
			type: 'string',
			title: 'Document Type',
			dropdown: true,
			width: 150,
			hidden: false,
			readOnly: false
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'DocumentLevel',
			width: 100,
			hidden: true,
			editable:false
		},
		Status: {
			class: 'status',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 150,
			hidden: false,
			readOnly: true,
			editable:false
		},
		TransactionID:{
			class: 'value',
			dataName: 'TransactionID',
			type: 'number',
			title: 'Transaction ID',
			width: 100,
			hidden: true,
			editable:false,
			readOnly:false
		},
		BatchGUID:{
			class: 'value',
			dataName: 'BatchGUID',
			type: 'number',
			title: 'Batch Id',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: false
		},
		ProgramIdList:{
			class: 'value',
			dataName: 'ProgramIdList',
			type: 'string',
			title: 'ProgramIdList',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: false
		},
		PartnerIdList:{
			class: 'value',
			dataName: 'PartnerIdList',
			type: 'string',
			title: 'PartnerIdList',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: false
		},
	}
}